module.exports = __webpack_public_path__ + "img/message_black.4df41edf.svg";